const existSubs = document.getElementById("exists-subs");

if( existSubs ) {
    existSubs.addEventListener("click", function (event) {
        event.preventDefault();
        let existingError = document.querySelector(".error-subs");
        if (existingError) {
            existingError.remove();
        }
        afrigar_message_element_input_validate('my-current-subscription', 'error error-subs', 'More Subscription not allowed, purchase more entries.');
    });
}